import React, { useEffect } from 'react';
import ReactDOM from "react-dom";
import styles from "./ActionRestrict.module.css"
import MailToSuperAdmin from 'app/common/mail-to/MailToSuperAdmin';

// container reference
let container = null;
let timer = null;
let navigationPatched = false;

function patchNavigationOnce() {
    if (navigationPatched) return;
    navigationPatched = true;

    const notifyRouteChange = () => {
        hideActionRestrict();
    };

    window.addEventListener("popstate", notifyRouteChange);

    const originalPushState = window.history.pushState;
    window.history.pushState = function (...args) {
        const result = originalPushState.apply(this, args);
        notifyRouteChange();
        return result;
    };

    const originalReplaceState = window.history.replaceState;
    window.history.replaceState = function (...args) {
        const result = originalReplaceState.apply(this, args);
        notifyRouteChange();
        return result;
    };
}

// Show function
export const showActionRestrict = (action=null) => {
    if (container) return;

    patchNavigationOnce();

    container = document.createElement("div");
    document.body.appendChild(container);

    ReactDOM.render(<ActionRestrict action={action} />, container);

    // auto remove after 5 sec
    timer = setTimeout(() => {
        hideActionRestrict();
    }, 5000);
};

//Hide function
export const hideActionRestrict = () => {
    if (container) {
        ReactDOM.unmountComponentAtNode(container);
        container.remove();
        container = null;
    }

    if (timer) {
        clearTimeout(timer);
        timer = null;
    }
};

// Component
function ActionRestrict({action=null}) 
{
    // cleanup safety (if unmounted early)
    useEffect(() => {
        return () => {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
        };
    }, []);

    return (
        <div className={styles.container}>
            <div className={styles.topic}>
                <div className={styles.icon}>⚠️</div>
                <div>
                    <h4 className={styles.heading}>Access Restricted</h4>
                    <div className={styles.info}>
                        <div>You don’t have access to this feature.</div>
                        <div>
                            Contact your Super Admin{" "}
                            <MailToSuperAdmin request={action}/> for permission.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ActionRestrict;